import { useEffect } from "react";

import { useRealtimeLastTradesFeatureFlag } from "#/hooks/featureFlags/useRealtimeLastTradesFeatureFlag";

import { useWorker } from "../useWorker";

export const useTrackFeatureFlags = () => {
  const { worker, isWorkerReady } = useWorker();
  const { isRealtimeLastTradesEnabled } = useRealtimeLastTradesFeatureFlag();

  useEffect(() => {
    if (!isWorkerReady) return;

    worker!.setValues({ featureFlags: { isRealtimeLastTradesEnabled } });
  }, [worker, isWorkerReady, isRealtimeLastTradesEnabled]);
};
